'use client';
import { HTMLMotionProps, motion, useInView } from 'motion/react';
import { FC, useRef } from 'react';

interface IFadeInProps extends HTMLMotionProps<'div'> {
  variant: 'right' | 'left' | 'up' | 'down';
  delay?: number;
  duration?: number;
}

const FadeIn: FC<IFadeInProps> = ({ variant, delay = 0, duration = 0.6, children, ...props }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  const animateConfig = {
    opacity: 0,
    x: variant === 'left' ? 50 : variant === 'right' ? -50 : 0,
    y: variant === 'up' ? 50 : variant === 'down' ? -50 : 0,
  };

  return (
    <motion.div
      {...props}
      ref={ref}
      initial={animateConfig} // Start below and hidden
      animate={
        isInView
          ? ['up', 'down'].includes(variant)
            ? { opacity: 1, y: 0 }
            : { opacity: 1, x: 0 }
          : animateConfig
      } // Fade in and slide up
      transition={{ duration, ease: 'easeOut', delay }}
    >
      {children}
    </motion.div>
  );
};

export default FadeIn;
